/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ValidateEmailCode Input Action
 */
export class ValidateEmailCodeInput implements Msdyn365.IActionInput {
    public emailAddress: string;
    public emailCode: string;
    constructor(emailAddress: string, emailCode: string) {
        this.emailAddress = emailAddress;
        this.emailCode = emailCode;
    }

    public getCacheKey = () => `DEFAULT + ${this.emailAddress} + ${this.emailCode} ${new Date()}`;
    public getCacheObjectType = () => `IValidateEmailCodeData ${new Date()}`;
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IValidateEmailCodeData {
    validCode: boolean;
    isUserExisting: boolean;
    existingProspect: boolean;
}

const createInput = (): Msdyn365.IActionInput => {
    return new ValidateEmailCodeInput('', '');
};

async function action(input: ValidateEmailCodeInput, ctx: Msdyn365.IActionContext): Promise<IValidateEmailCodeData> {
    let result: IValidateEmailCodeData = {
        validCode: false,
        isUserExisting: false,
        existingProspect: false
    };

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/CheckEmailVerificationToken(email='${input.emailAddress}',token='${input.emailCode}')`,
        'get',
        {},
        { headers: { oun: ctx.requestContext.apiSettings.oun } }
    ).then(res => {
        result = {
            validCode: (res?.data as any)?.IsCodeValid || false,
            isUserExisting: (res?.data as any)?.ExistingUser || false,
            existingProspect: (res?.data as any)?.ExistingProspect || false
        };
    });

    return {
        validCode: result.validCode,
        isUserExisting: result.isUserExisting,
        existingProspect: result.existingProspect
    };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IValidateEmailCodeData>>action,
    id: 'CheckEmailVerificationToken',
    input: createInput
});
